import React from 'react';
import type { ProjectStatus } from '../types/project';
const styles: Record<ProjectStatus, string> = {
  activo: 'border-teal-dim text-teal',
  estable: 'border-hairline text-ink-hi',
  concepto: 'border-magenta-dim text-magenta',
  entregado: 'border-hairline text-ink-mid'
};
const labels: Record<ProjectStatus, string> = {
  activo: 'En desarrollo activo',
  estable: 'En uso / estable',
  concepto: 'En concepto',
  entregado: 'Entregado'
};
export function StatusTag({
  status
}: {
  status: ProjectStatus;
}) {
  return <span className={`inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 font-mono text-[11px] ${styles[status]}`} data-id="element-239" data-mp="2dktbkhbmoqqj">
      {labels[status]}
    </span>;
}